import useSWR from "swr";
import { useRediaPlatformContext } from "../../../rediaPlatform/RediaPlatformProvider";

export const usePatronConfiguration = () => {
  const { rediaPlatform } = useRediaPlatformContext();
  const swrCacheKey = rediaPlatform ? "rediaPlatform:patronConfiguration" : null;
  return useSWR(swrCacheKey, () => rediaPlatform?.getPatronConfiguration());
};
